import React, { useEffect, useState } from 'react';
import ShopSection from '../components/ShopSection';
import { Link, useNavigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import {
    Sparkles,
    Dumbbell,
    ShieldCheck,
    Clock,
    Users,
    Award,
    Eye,
    X,
    Check,
    ChevronRight,
    Phone,
    Calendar,
    Zap
} from 'lucide-react';

interface ServiceCardItem {
    id: string;
    image: string;
    badge: string;
    category: 'all' | 'tarifs' | 'disciplines' | 'organisation';
    title: string;
    tagline: string;
    description: string;
    highlights: string[];
    priceTag: string;
}

const serviceItems: ServiceCardItem[] = [
    {
        id: 'prestations',
        image: '/pre1.jpeg',
        badge: '6 Disciplines',
        category: 'disciplines',
        title: 'Nos Prestations & Univers Sportifs',
        tagline: 'Une seule maison, la puissance !',
        description: 'Un complexe sportif d\'élite regroupant 6 disciplines complémentaires : Musculation haute intensité, Cardio-training endurance, Fitness collectif dynamique, Boxe anglaise de combat, Taekwondo juniors et un Espace Fauteuils Massants pour une récupération musculaire maximale.',
        highlights: [
            'Musculation & Cardio haute performance',
            'Boxe & Taekwondo tous niveaux encadrés',
            'Espace Fauteuils de Massage & Récupération'
        ],
        priceTag: 'Pôle Multi-Activités'
    },
    {
        id: 'abonnements',
        image: '/img12.jpeg',
        badge: 'Formules Gym',
        category: 'tarifs',
        title: 'Abonnements & Tarifs Tout Compris',
        tagline: 'Accès illimité aux espaces & coaching basique',
        description: 'Des formules flexibles et dégressives pour s\'entraîner en toute liberté : séance unitaire (3 000 F), mensuel (25 000 F), trimestriel (70 000 F), semestriel (130 000 F) et annuel (240 000 F avec 60 000 F d\'économie). Accès libre aux équipements et conseils coach offerts.',
        highlights: [
            'Séance 3 000 FCFA | Mensuel 25 000 FCFA',
            'Accès illimité 7j/7 aux installations modernes',
            'Droit au coaching basique inclus sans surcoût'
        ],
        priceTag: 'Dès 25.000 FCFA / mois'
    },
    {
        id: 'coaching-perso',
        image: '/img8.jpeg',
        badge: 'Accompagnement VIP',
        category: 'tarifs',
        title: 'Coaching Personnel & Suivi Nutritionnel',
        tagline: 'Atteins tes objectifs avec un coach dédié',
        description: 'Un suivi one-on-one sur-mesure pour accélérer votre transformation : Formules Standard (75 000 F / 8 000 F la séance), Avancée (100 000 F avec nutrition) et Premium VIP (150 000 F avec dotations offertes : serviettes, packs d\'eau et barres protéinées).',
        highlights: [
            'Formules Standard, Avancée & Premium VIP',
            'Plans d\'entraînement & rééquilibrage alimentaire',
            'Avantages VIP offerts (serviettes, eau & collations)'
        ],
        priceTag: 'Dès 8.000 FCFA / séance'
    },
    {
        id: 'boxe',
        image: '/img5.jpeg',
        badge: 'Ring & Combat',
        category: 'disciplines',
        title: 'Académie de Boxe & Sparring d\'Élite',
        tagline: 'Dépassement, technique & mental d\'acier',
        description: 'Développez explosivité, réflexes et condition physique lors de nos entraînements intenses de boxe les mercredis, samedis et dimanches de 16h00 à 17h30. Profitez aussi du Pass Combiné exclusif Mensuel Gym + Boxe à 50 000 F avec 5 000 F d\'économie immédiate !',
        highlights: [
            'Mercredi, Samedi & Dimanche (16h00 - 17h30)',
            'Séance Boxe 5 000 F | Mensuel Boxe 30 000 F',
            'Pass Duo Gym + Boxe remisé à 50 000 FCFA'
        ],
        priceTag: 'Pass Duo Gym+Boxe 50.000 F'
    },
    {
        id: 'pack-entreprise',
        image: '/img11.jpeg',
        badge: 'Solutions Corporate',
        category: 'tarifs',
        title: 'Pack Entreprise : Bien-Être & Cohésion',
        tagline: 'Plus qu\'une salle, un investissement pour vos équipes !',
        description: 'Dynamisez la santé et la synergie de vos équipes grâce à notre tarif corporatif préférentiel à 20 000 F/personne/mois (dès 5 collaborateurs). Possibilité exclusive de détacher un coach d\'élite directement au sein de vos locaux professionnels.',
        highlights: [
            'Tarif remisé à 20 000 FCFA / pers / mois',
            'Accessible dès 5 collaborateurs d\'une même structure',
            'Coaching en entreprise disponible dans vos locaux'
        ],
        priceTag: '20.000 FCFA / pers / mois'
    },
    {
        id: 'taekwondo-securite',
        image: '/img4.jpeg',
        badge: 'Arts Martiaux Juniors',
        category: 'disciplines',
        title: 'Taekwondo Enfants & Sécurité Badge Certifiée',
        tagline: 'Discipline, Confiance, Respect & Protection',
        description: 'Initiez vos enfants à l\'art martial formatrice du Taekwondo dans un encadrement sécurisé irréprochable : chaque enfant reçoit une carte d\'identification nominative avec QR Code, et aucune sortie n\'est permise sans la présentation de la carte autorisée parent/tuteur.',
        highlights: [
            'Discipline, self-défense & confiance en soi',
            'Cartes d\'identification individuelles avec QR Code',
            'Restitution sous contrôle strict parent/tuteur'
        ],
        priceTag: 'Protection & Traçabilité QR'
    },
    {
        id: 'horaires-organisation',
        image: '/img3.jpeg',
        badge: 'Organisation des Espaces',
        category: 'organisation',
        title: 'Organisation & Fonctionnement de la Salle',
        tagline: 'Une structure claire pour mieux vous accompagner',
        description: 'Une gestion fluide pensée pour votre confort et vos résultats : salle accessible en continu de 06h30 à 22h30, assistance permanente de nos instructeurs de 07h00 à 22h00 pour vos mouvements, et créneaux dédiés au coaching sur rendez-vous pour préserver l\'espace.',
        highlights: [
            'Accès libre aux équipements de 06h30 à 22h30',
            'Assistance technique des coachs de 07h00 à 22h00',
            'Créneaux régulés pour éviter toute suraffluence'
        ],
        priceTag: 'Plateau ouvert dès 06h30'
    },
    {
        id: 'acces-securise',
        image: '/img6.jpeg',
        badge: 'Contrôle Numérique',
        category: 'organisation',
        title: 'Accès Contrôlé par QR Code & Badge Connecté',
        tagline: 'Sécurité garantie, confort & accès maîtrisé',
        description: 'Pour préserver la tranquillité et l\'exclusivité de vos sessions sportives, le passage par la réception est obligatoire avant d\'accéder aux espaces d\'entraînement. Validez votre entrée en un instant via le scan de votre QR Code ou par présentation de votre carte badge.',
        highlights: [
            'Passage systématique obligatoire à la réception',
            'Double vérification : QR Code smartphone ou Carte Badge',
            'Atmosphère sportive maîtrisée et 100% sécurisée'
        ],
        priceTag: 'Check-in Rapide & Sécurisé'
    },
    {
        id: 'ouverture-7j7',
        image: '/img2.jpeg',
        badge: 'Disponibilité 7J/7',
        category: 'organisation',
        title: 'Ouverture Non-Stop 7J/7 & Jours Fériés',
        tagline: 'La liberté de s\'entraîner 365 jours par an',
        description: 'Finies les contraintes de planning ! HopFitness vous accueille du Lundi au Samedi de 06h30 à 22h30, les dimanches de 09h00 à 20h00 et tous les jours fériés de 06h30 à 22h30. Une disponibilité totale pour garder le cap sur vos objectifs physiques toute l\'année.',
        highlights: [
            'Lundi au Samedi : 06h30 à 22h30 sans coupure',
            'Dimanche : 09h00 à 20h00',
            'Ouvert également tous les jours fériés de l\'année'
        ],
        priceTag: '365 jours par an'
    }
];

const LandingPage = () => {
    const user = useAuthStore(state => state.user);
    const logout = useAuthStore(state => state.logout);
    const navigate = useNavigate();

    const [selectedService, setSelectedService] = useState<ServiceCardItem | null>(null);
    const [activeCategory, setActiveCategory] = useState<'all' | 'tarifs' | 'disciplines' | 'organisation'>('all');

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setSelectedService(null);
        };
        if (selectedService) {
            document.body.style.overflow = 'hidden';
            window.addEventListener('keydown', handleKeyDown);
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [selectedService]);

    const categories = [
        { id: 'all' as const, label: 'Toutes les offres & affiches', count: serviceItems.length },
        { id: 'tarifs' as const, label: 'Tarifs & Abonnements', count: serviceItems.filter(s => s.category === 'tarifs').length },
        { id: 'disciplines' as const, label: 'Disciplines & Boxe', count: serviceItems.filter(s => s.category === 'disciplines').length },
        { id: 'organisation' as const, label: 'Horaires & Organisation', count: serviceItems.filter(s => s.category === 'organisation').length }
    ];

    const filteredServices = activeCategory === 'all'
        ? serviceItems
        : serviceItems.filter(item => item.category === activeCategory);

    return (
        <>
            <div className="site-wrap">
                <div className="site-mobile-menu site-navbar-target">
                    <div className="site-mobile-menu-header">
                        <div className="site-mobile-menu-close mt-3">
                            <span className="icon-close2 js-menu-toggle"></span>
                        </div>
                    </div>
                    <div className="site-mobile-menu-body"></div>
                </div>

                <header className="site-navbar py-4 js-sticky-header site-navbar-target" role="banner">
                    <div className="container-fluid">
                        <div className="d-flex align-items-center">
                            <div className="site-logo"><a href="index.html">HOPFITNESS<span>.</span> </a></div>
                            <div className="ml-auto">
                                <nav className="site-navigation position-relative text-right" role="navigation">
                                    <ul className="site-menu main-menu js-clone-nav mr-auto d-none d-lg-block">
                                        <li><a href="#home-section" className="nav-link">Accueil</a></li>
                                        <li><a href="#classes-section" className="nav-link">Cours</a></li>
                                        <li><a href="#shop-section" className="nav-link">Boutique</a></li>
                                        <li><a href="#trainer-section" className="nav-link">Entraîneurs</a></li>
                                        <li><a href="#services-section" className="nav-link">Services</a></li>
                                        <li><a href="#contact-section" className="nav-link">Contact</a></li>
                                        {user && <li><Link to="/my-orders" className="nav-link" style={{ color: '#eab308' }}>Mes Commandes</Link></li>}
                                    </ul>
                                </nav>
                                <a href="#" className="d-inline-block d-lg-none site-menu-toggle js-menu-toggle float-right"><span className="icon-menu h3"></span></a>
                            </div>
                        </div>
                    </div>
                </header>

                <a id="bgndVideo" className="player"
                    data-property="{videoURL:'https://www.youtube.com/watch?v=w-cRWOjlk8c',showYTLogo:false, showAnnotations: false, showControls: false, cc_load_policy: false, containment:'#home-section',autoPlay:true, mute:true, startAt:255, stopAt: 271, opacity:1}">
                </a>

                <div className="intro-section" id="home-section" style={{ backgroundColor: '#ccc' }}>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-12 mx-auto text-center" data-aos="fade-up">
                                <h1 className="mb-3 font-extrabold text-5xl md:text-7xl" style={{ color: '#eab308' }}>HopFitness : House Of Power </h1>
                                <p className="lead mx-auto desc mb-5 text-gray-300 leading-relaxed">Rejoignez-nous pour atteindre vos objectifs avec nos entraîneurs professionnels.</p>
                                <div className="text-center text-gray-300 leading-relaxed flex justify-center gap-4">
                                    {user ? (
                                        <>
                                            <Link to="/my-orders" className="btn btn-outline-white py-3 px-5 font-bold">Mes Commandes</Link>
                                            <button onClick={() => { logout(); navigate('/'); }} className="btn btn-primary py-3 px-5 font-bold" style={{ backgroundColor: '#eab308', color: 'black' }}>Se déconnecter</button>
                                        </>
                                    ) : (
                                        <Link to="/login" className="btn btn-outline-white py-3 px-5 font-bold">Se connecter</Link>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="schedule-wrap p-4 bg-[#1a1a1a]">
                    <div className="d-md-flex align-items-center justify-content-between">
                        <div className="hours mb-4 mb-lg-0 text-white flex-1 w-full">
                            <strong className="d-block text-yellow-500 text-xl mb-3 font-black uppercase tracking-wider">HORAIRE (Ouvert 7J/7)</strong>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm">
                                <div className="space-y-2">
                                    <div className="flex justify-between border-b border-gray-700 pb-1"><span className="font-bold text-gray-300">LUNDI-SAMEDI :</span> <span className="text-yellow-400 font-medium">06H30 - 22H30</span></div>
                                    <div className="flex justify-between border-b border-gray-700 pb-1"><span className="font-bold text-gray-300">DIMANCHE :</span> <span className="text-yellow-400 font-medium">09H00 - 20H00</span></div>
                                    <div className="flex justify-between border-b border-gray-700 pb-1"><span className="font-bold text-gray-300">FÉRIÉ :</span> <span className="text-yellow-400 font-medium">06H30 - 22H30</span></div>
                                </div>
                                <div className="bg-yellow-500/10 p-3 rounded-lg border border-yellow-500/30 text-xs text-gray-300">
                                    <span className="text-yellow-500 font-bold block mb-1">⚠️ NB :</span>
                                    LA PAUSE EST DE 12H30 À 15H30. LES CLIENTS PEUVENT S'ENTRAÎNER LIBREMENT, MAIS SANS LES COACHS.
                                </div>
                            </div>
                        </div>
                        <div className="cta ml-md-8 mt-4 md:mt-0 flex flex-col items-center justify-center shrink-0">
                            <div className="text-white font-black text-2xl mb-3 bg-black/20 px-4 py-2 rounded-lg whitespace-nowrap">
                                📞 01 01 58 50 53
                            </div>
                            <a href="#contact-section" className="smoothscroll d-flex d-md-flex align-items-center btn w-full" style={{ backgroundColor: '#eab308', color: 'black' }}>
                                <span className="mx-auto">  <span>Nous contacter</span> <span className="arrow icon-keyboard_arrow_right"></span></span>
                            </a>
                        </div>
                    </div>
                </div>

                <div className="site-section bg-[#121212]">
                    <div className="container">

                        <div className="row justify-content-center text-center mb-5">
                            <div className="col-md-8 section-heading">
                                <span className="subheading font-extrabold uppercase tracking-widest text-sm" style={{ color: "#eab308" }}>Restez en forme</span>
                                <h2 className="heading mb-3 font-extrabold text-4xl" style={{ color: "#eab308" }}>Obtenez un corps parfait</h2>
                                <p className="text-gray-300 leading-relaxed text-gray-300 leading-relaxed">Découvrez nos installations modernes et nos cours variés pour tous les niveaux.
                                    Rejoignez une communauté motivée et atteignez vos objectifs santé.</p>
                            </div>
                        </div>

                        {/* Slider */}
                        <div className="owl-carousel nonloop-block-14 block-14" data-aos="fade">
                            <div className="slide">
                                <div className="ftco-feature-1 bg-[#1a1a1a] p-8 mx-2 rounded-3xl border-2 border-[#eab308] shadow-[0_4px_20px_rgba(0,0,0,0.5)] hover:shadow-[0_8px_30px_rgba(255,204,0,0.3)] hover:-translate-y-2 transition-all duration-300 flex flex-col items-center text-center group h-full">
                                    <span className="icon flaticon-fit text-6xl mb-5 group-hover:scale-110 transition-transform duration-300" style={{ color: "#eab308" }}></span>
                                    <div className="ftco-feature-1-text">
                                        <h2 className="text-white font-bold text-2xl mb-4 group-hover:text-yellow-400 transition-colors">Soyez en forme</h2>
                                        <p className="text-gray-300 leading-relaxed text-gray-300 leading-relaxed">Découvrez nos installations modernes et nos cours variés pour tous les niveaux.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="slide">
                                <div className="ftco-feature-1 bg-[#1a1a1a] p-8 mx-2 rounded-3xl border-2 border-[#eab308] shadow-[0_4px_20px_rgba(0,0,0,0.5)] hover:shadow-[0_8px_30px_rgba(255,204,0,0.3)] hover:-translate-y-2 transition-all duration-300 flex flex-col items-center text-center group h-full">
                                    <span className="icon flaticon-gym-1 text-6xl mb-5 group-hover:scale-110 transition-transform duration-300" style={{ color: "#eab308" }}></span>
                                    <div className="ftco-feature-1-text">
                                        <h2 className="text-white font-bold text-2xl mb-4 group-hover:text-yellow-400 transition-colors">Rejoindre le club</h2>
                                        <p className="text-gray-300 leading-relaxed text-gray-300 leading-relaxed">Des coachs passionnés pour vous guider, vous motiver et vous aider à dépasser vos limites, quel que soit votre niveau.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="slide">
                                <div className="ftco-feature-1 bg-[#1a1a1a] p-8 mx-2 rounded-3xl border-2 border-[#eab308] shadow-[0_4px_20px_rgba(0,0,0,0.5)] hover:shadow-[0_8px_30px_rgba(255,204,0,0.3)] hover:-translate-y-2 transition-all duration-300 flex flex-col items-center text-center group h-full">
                                    <span className="icon flaticon-gym text-6xl mb-5 group-hover:scale-110 transition-transform duration-300" style={{ color: "#eab308" }}></span>
                                    <div className="ftco-feature-1-text">
                                        <h2 className="text-white font-bold text-2xl mb-4 group-hover:text-yellow-400 transition-colors">Fitness & Musculation</h2>
                                        <p className="text-gray-300 leading-relaxed text-gray-300 leading-relaxed">Des coachs passionnés pour vous guider, vous motiver et vous aider à dépasser vos limites, quel que soit votre niveau.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="slide">
                                <div className="ftco-feature-1 bg-[#1a1a1a] p-8 mx-2 rounded-3xl border-2 border-[#eab308] shadow-[0_4px_20px_rgba(0,0,0,0.5)] hover:shadow-[0_8px_30px_rgba(255,204,0,0.3)] hover:-translate-y-2 transition-all duration-300 flex flex-col items-center text-center group h-full">
                                    <span className="icon flaticon-vegetables text-6xl mb-5 group-hover:scale-110 transition-transform duration-300" style={{ color: "#eab308" }}></span>
                                    <div className="ftco-feature-1-text">
                                        <h2 className="text-white font-bold text-2xl mb-4 group-hover:text-yellow-400 transition-colors">Alimentation saine</h2>
                                        <p className="text-gray-300 leading-relaxed text-gray-300 leading-relaxed">Des coachs passionnés pour vous guider, vous motiver et vous aider à dépasser vos limites, quel que soit votre niveau.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="slide">
                                <div className="ftco-feature-1 bg-[#1a1a1a] p-8 mx-2 rounded-3xl border-2 border-[#eab308] shadow-[0_4px_20px_rgba(0,0,0,0.5)] hover:shadow-[0_8px_30px_rgba(255,204,0,0.3)] hover:-translate-y-2 transition-all duration-300 flex flex-col items-center text-center group h-full">
                                    <span className="icon flaticon-fruit-juice text-6xl mb-5 group-hover:scale-110 transition-transform duration-300" style={{ color: "#eab308" }}></span>
                                    <div className="ftco-feature-1-text">
                                        <h2 className="text-white font-bold text-2xl mb-4 group-hover:text-yellow-400 transition-colors">Jus de fruits</h2>
                                        <p className="text-gray-300 leading-relaxed text-gray-300 leading-relaxed">Des coachs passionnés pour vous guider, vous motiver et vous aider à dépasser vos limites, quel que soit votre niveau.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="slide">
                                <div className="ftco-feature-1 bg-[#1a1a1a] p-8 mx-2 rounded-3xl border-2 border-[#eab308] shadow-[0_4px_20px_rgba(0,0,0,0.5)] hover:shadow-[0_8px_30px_rgba(255,204,0,0.3)] hover:-translate-y-2 transition-all duration-300 flex flex-col items-center text-center group h-full">
                                    <span className="icon flaticon-stationary-bike text-6xl mb-5 group-hover:scale-110 transition-transform duration-300" style={{ color: "#eab308" }}></span>
                                    <div className="ftco-feature-1-text">
                                        <h2 className="text-white font-bold text-2xl mb-4 group-hover:text-yellow-400 transition-colors">Échauffement</h2>
                                        <p className="text-gray-300 leading-relaxed text-gray-300 leading-relaxed">Des coachs passionnés pour vous guider, vous motiver et vous aider à dépasser vos limites, quel que soit votre niveau.</p>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

                <div className="bgimg" style={{ backgroundImage: "url('images/bg_2.jpg')" }} data-stellar-background-ratio="0.5">

                    <div className="container">
                        <div className="row align-items-center justify-content-center text-center">
                            <div className="col-md-7">
                                <h2 className="font-extrabold text-4xl mb-4" style={{ color: "#eab308" }}>Obtenez les résultats souhaités</h2>
                                <p className="lead mx-auto desc mb-5 text-gray-300 leading-relaxed">Rejoignez-nous pour atteindre vos objectifs avec nos entraîneurs professionnels.</p>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="site-section bg-[#121212]" id="classes-section">
                    <div className="container">
                        <div className="row justify-content-center text-center mb-5">
                            <div className="col-md-8  section-heading">
                                <span className="subheading font-extrabold uppercase tracking-widest text-sm" style={{ color: "#eab308" }}>Cours de Fitness</span>
                                <h2 className="heading mb-3 font-extrabold text-4xl" style={{ color: "#eab308" }}>Cours</h2>
                                <p className="text-gray-300 leading-relaxed text-gray-300 leading-relaxed">Découvrez nos installations modernes et nos cours variés pour tous les niveaux.
                                    Rejoignez une communauté motivée et atteignez vos objectifs santé.</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="class-item d-flex align-items-center">
                                    <a href="single.html" className="class-item-thumbnail">
                                        <img src="images/img_1.jpg" alt="Free website template by Free-Template.co" />
                                    </a>
                                    <div className="class-item-text">

                                        <h2 className="text-white font-bold text-2xl mb-4 group-hover:text-yellow-400 transition-colors"><a href="single.html">Cours de Fitness Name #1</a></h2>
                                        <span>By Justin Daniel</span>,
                                        <span>30 minutes</span>
                                    </div>
                                </div>

                                <div className="class-item d-flex align-items-center">
                                    <a href="single.html" className="class-item-thumbnail">
                                        <img src="images/img_2.jpg" alt="Free website template by Free-Template.co" />
                                    </a>
                                    <div className="class-item-text">

                                        <h2 className="text-white font-bold text-2xl mb-4 group-hover:text-yellow-400 transition-colors"><a href="single.html">Cours de Fitness Name #2</a></h2>
                                        <span>By Justin Daniel</span>,
                                        <span>30 minutes</span>
                                    </div>
                                </div>

                                <div className="class-item d-flex align-items-center">
                                    <a href="single.html" className="class-item-thumbnail">
                                        <img src="images/img_3.jpg" alt="Free website template by Free-Template.co" />
                                    </a>
                                    <div className="class-item-text">

                                        <h2 className="text-white font-bold text-2xl mb-4 group-hover:text-yellow-400 transition-colors"><a href="single.html">Cours de Fitness Name #3</a></h2>
                                        <span>By Justin Daniel</span>,
                                        <span>30 minutes</span>
                                    </div>
                                </div>

                                <div className="class-item d-flex align-items-center">
                                    <a href="single.html" className="class-item-thumbnail">
                                        <img src="images/img_4.jpg" alt="Free website template by Free-Template.co" />
                                    </a>
                                    <div className="class-item-text">

                                        <h2 className="text-white font-bold text-2xl mb-4 group-hover:text-yellow-400 transition-colors"><a href="single.html">Cours de Fitness Name #4</a></h2>
                                        <span>By Justin Daniel</span>,
                                        <span>30 minutes</span>
                                    </div>
                                </div>

                                <div className="class-item d-flex align-items-center">
                                    <a href="single.html" className="class-item-thumbnail">
                                        <img src="images/img_1.jpg" alt="Free website template by Free-Template.co" />
                                    </a>
                                    <div className="class-item-text">

                                        <h2 className="text-white font-bold text-2xl mb-4 group-hover:text-yellow-400 transition-colors"><a href="single.html">Cours de Fitness Name #5</a></h2>
                                        <span>By Justin Daniel</span>,
                                        <span>30 minutes</span>
                                    </div>
                                </div>


                            </div>
                            <div className="col-lg-6">
                                <div className="class-item d-flex align-items-center">
                                    <a href="single.html" className="class-item-thumbnail">
                                        <img src="images/img_1.jpg" alt="Free website template by Free-Template.co" />
                                    </a>
                                    <div className="class-item-text">

                                        <h2 className="text-white font-bold text-2xl mb-4 group-hover:text-yellow-400 transition-colors"><a href="single.html">Cours de Fitness Name #1</a></h2>
                                        <span>By Justin Daniel</span>,
                                        <span>30 minutes</span>
                                    </div>
                                </div>

                                <div className="class-item d-flex align-items-center">
                                    <a href="single.html" className="class-item-thumbnail">
                                        <img src="images/img_2.jpg" alt="Free website template by Free-Template.co" />
                                    </a>
                                    <div className="class-item-text">

                                        <h2 className="text-white font-bold text-2xl mb-4 group-hover:text-yellow-400 transition-colors"><a href="single.html">Cours de Fitness Name #2</a></h2>
                                        <span>By Justin Daniel</span>,
                                        <span>30 minutes</span>
                                    </div>
                                </div>

                                <div className="class-item d-flex align-items-center">
                                    <a href="single.html" className="class-item-thumbnail">
                                        <img src="images/img_3.jpg" alt="Free website template by Free-Template.co" />
                                    </a>
                                    <div className="class-item-text">

                                        <h2 className="text-white font-bold text-2xl mb-4 group-hover:text-yellow-400 transition-colors"><a href="single.html">Cours de Fitness Name #3</a></h2>
                                        <span>By Justin Daniel</span>,
                                        <span>30 minutes</span>
                                    </div>
                                </div>

                                <div className="class-item d-flex align-items-center">
                                    <a href="single.html" className="class-item-thumbnail">
                                        <img src="images/img_4.jpg" alt="Free website template by Free-Template.co" />
                                    </a>
                                    <div className="class-item-text">

                                        <h2 className="text-white font-bold text-2xl mb-4 group-hover:text-yellow-400 transition-colors"><a href="single.html">Cours de Fitness Name #4</a></h2>
                                        <span>By Justin Daniel</span>,
                                        <span>30 minutes</span>
                                    </div>
                                </div>

                                <div className="class-item d-flex align-items-center">
                                    <a href="single.html" className="class-item-thumbnail">
                                        <img src="images/img_1.jpg" alt="Free website template by Free-Template.co" />
                                    </a>
                                    <div className="class-item-text">

                                        <h2 className="text-white font-bold text-2xl mb-4 group-hover:text-yellow-400 transition-colors"><a href="single.html">Cours de Fitness Name #5</a></h2>
                                        <span>By Justin Daniel</span>,
                                        <span>30 minutes</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bgimg" style={{ backgroundImage: "url('images/bg_3.jpg')" }} data-stellar-background-ratio="0.5">
                    <div className="container">
                        <div className="row align-items-center justify-content-center text-center">
                            <div className="col-md-7">
                                <h2 className="font-extrabold text-4xl mb-4" style={{ color: "#eab308" }}>Chaque pas compte</h2>
                                <p className="lead mx-auto desc mb-5 text-gray-300 leading-relaxed">Rejoignez-nous pour atteindre vos objectifs avec nos entraîneurs professionnels.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <ShopSection />

                <div className="site-section bg-[#121212]" id="trainer-section">
                    <div className="container">
                        <div className="row justify-content-center text-center mb-5" data-aos="fade-up">
                            <div className="col-md-8  section-heading">
                                <span className="subheading font-extrabold uppercase tracking-widest text-sm" style={{ color: "#eab308" }}>Entraîneurs</span>
                                <h2 className="heading mb-3 font-extrabold text-4xl" style={{ color: "#eab308" }}>Nos Entraîneurs</h2>
                                <p className="text-gray-300 leading-relaxed text-gray-300 leading-relaxed">Des coachs passionnés pour vous guider, vous motiver et vous aider à dépasser vos limites, quel que soit votre niveau.
                                    Rejoignez une communauté motivée et atteignez vos objectifs santé.</p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-3 mb-4 mb-lg-0 col-md-6 text-center" data-aos="fade-up" data-aos-delay="">
                                <div className="person">
                                    <img src="images/person_1.jpg" alt="Free website template by Free-Template.co" className="img-fluid" />
                                    <h3 className="text-white font-bold text-2xl mb-1">Justin Daniel</h3>
                                    <p className="position text-gray-300 leading-relaxed">Entraîneurs</p>
                                    <p className="text-gray-300 leading-relaxed text-gray-300 leading-relaxed">Des coachs passionnés pour vous guider, vous motiver et vous aider à dépasser vos limites, quel que soit votre niveau.</p>
                                </div>
                            </div>
                            <div className="col-lg-3 mb-4 mb-lg-0 col-md-6 text-center" data-aos="fade-up" data-aos-delay="100">
                                <div className="person">
                                    <img src="images/person_3.jpg" alt="Free website template by Free-Template.co" className="img-fluid" />
                                    <h3 className="text-white font-bold text-2xl mb-1">Matthew Davidson</h3>
                                    <p className="position text-gray-300 leading-relaxed">Entraîneurs</p>
                                    <p className="text-gray-300 leading-relaxed text-gray-300 leading-relaxed">Des coachs passionnés pour vous guider, vous motiver et vous aider à dépasser vos limites, quel que soit votre niveau.</p>
                                </div>
                            </div>
                            <div className="col-lg-3 mb-4 mb-lg-0 col-md-6 text-center" data-aos="fade-up" data-aos-delay="200">
                                <div className="person">
                                    <img src="images/person_2.jpg" alt="Free website template by Free-Template.co" className="img-fluid" />
                                    <h3 className="text-white font-bold text-2xl mb-1">Matthew Davidson</h3>
                                    <p className="position text-gray-300 leading-relaxed">Entraîneurs</p>
                                    <p className="text-gray-300 leading-relaxed text-gray-300 leading-relaxed">Des coachs passionnés pour vous guider, vous motiver et vous aider à dépasser vos limites, quel que soit votre niveau.</p>
                                </div>
                            </div>
                            <div className="col-lg-3 mb-4 mb-lg-0 col-md-6 text-center" data-aos="fade-up" data-aos-delay="300">
                                <div className="person">
                                    <img src="images/person_4.jpg" alt="Free website template by Free-Template.co" className="img-fluid" />
                                    <h3 className="text-white font-bold text-2xl mb-1">Matthew Davidson</h3>
                                    <p className="position text-gray-300 leading-relaxed">Entraîneurs</p>
                                    <p className="text-gray-300 leading-relaxed text-gray-300 leading-relaxed">Des coachs passionnés pour vous guider, vous motiver et vous aider à dépasser vos limites, quel que soit votre niveau.</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="site-section bg-[#121212]" id="services-section">
                    <div className="container">
                        {/* Section Header */}
                        <div className="row justify-content-center text-center mb-5" data-aos="fade-up">
                            <div className="col-md-9 section-heading">
                                <span className="subheading font-extrabold uppercase tracking-widest text-sm inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-yellow-500/10 border border-yellow-500/30 mb-3" style={{ color: "#eab308" }}>
                                    <Sparkles size={16} /> Programmes & Affiches Officielles
                                </span>
                                <h2 className="heading mb-3 font-extrabold text-4xl md:text-5xl" style={{ color: "#eab308" }}>
                                    Nos Services & Formules
                                </h2>
                                <p className="text-gray-300 leading-relaxed max-w-2xl mx-auto text-base">
                                    Découvrez nos disciplines d'élite, nos tarifs d'abonnements, nos programmes de combat et toutes les informations pratiques de HopFitness. Cliquez sur une affiche pour afficher tous les détails en grand format.
                                </p>

                                {/* Filter Tabs */}
                                <div className="flex flex-wrap items-center justify-center gap-2.5 mt-8">
                                    {categories.map((cat) => (
                                        <button
                                            key={cat.id}
                                            type="button"
                                            onClick={() => setActiveCategory(cat.id)}
                                            className={`px-4 py-2 rounded-full text-sm font-bold transition-all duration-300 flex items-center gap-2 cursor-pointer border ${activeCategory === cat.id
                                                ? 'bg-[#eab308] text-black border-[#eab308] shadow-[0_4px_15px_rgba(234,179,8,0.4)] scale-105'
                                                : 'bg-[#1e1e1e] text-gray-300 hover:text-white hover:bg-[#282828] border-white/10'
                                                }`}
                                        >
                                            <span>{cat.label}</span>
                                            <span className={`text-xs px-2 py-0.5 rounded-full ${activeCategory === cat.id ? 'bg-black/20 text-black font-black' : 'bg-white/10 text-gray-400'
                                                }`}>
                                                {cat.count}
                                            </span>
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Services Grid */}
                        <div className="row">
                            {filteredServices.map((item, idx) => (
                                <div key={item.id} className="col-lg-4 col-md-6 mb-4" data-aos="fade-up" data-aos-delay={idx * 50}>
                                    <div
                                        onClick={() => setSelectedService(item)}
                                        className="ftco-feature-1 bg-[#1a1a1a] rounded-3xl border-2 border-[#eab308]/40 hover:border-[#eab308] shadow-[0_4px_20px_rgba(0,0,0,0.6)] hover:shadow-[0_10px_35px_rgba(234,179,8,0.25)] hover:-translate-y-2 transition-all duration-300 flex flex-col h-full overflow-hidden group cursor-pointer"
                                    >
                                        {/* Poster Media Box */}
                                        <div className="relative bg-black/60 p-3 overflow-hidden">
                                            <div className="w-full h-80 rounded-2xl overflow-hidden bg-black/40 flex items-center justify-center relative">
                                                <img
                                                    src={item.image}
                                                    alt={item.title}
                                                    className="w-full h-full object-contain rounded-2xl group-hover:scale-105 transition-transform duration-500"
                                                />
                                                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/10 opacity-30 group-hover:opacity-60 transition-opacity duration-300 pointer-events-none" />
                                            </div>

                                            {/* Floating Category Badge */}
                                            <div className="absolute top-5 left-5 bg-[#eab308] text-black font-extrabold text-xs px-3 py-1.5 rounded-full shadow-lg tracking-wider uppercase flex items-center gap-1.5">
                                                {item.category === 'tarifs' && <Award size={13} />}
                                                {item.category === 'disciplines' && <Dumbbell size={13} />}
                                                {item.category === 'organisation' && <Clock size={13} />}
                                                <span>{item.badge}</span>
                                            </div>

                                            {/* Floating Quick Zoom Prompt */}
                                            <div className="absolute bottom-5 right-5 bg-black/80 backdrop-blur-md border border-[#eab308]/60 text-[#eab308] group-hover:bg-[#eab308] group-hover:text-black text-xs font-bold px-3 py-1.5 rounded-full flex items-center gap-1.5 shadow-lg transition-all duration-300">
                                                <Eye size={14} />
                                                <span>Agrandir</span>
                                            </div>
                                        </div>

                                        {/* Card Content */}
                                        <div className="p-5 flex flex-col flex-grow text-left">
                                            <span className="text-xs font-bold text-[#eab308] uppercase tracking-wider mb-1 block">
                                                {item.tagline}
                                            </span>
                                            <h3 className="text-white font-extrabold text-xl mb-2.5 group-hover:text-yellow-400 transition-colors line-clamp-2">
                                                {item.title}
                                            </h3>
                                            <p className="text-gray-300 text-sm leading-relaxed mb-4 flex-grow line-clamp-3">
                                                {item.description}
                                            </p>

                                            {/* Highlights Checklist */}
                                            <ul className="space-y-1.5 mb-5 pt-3 border-t border-white/10 text-xs text-gray-300">
                                                {item.highlights.map((h, i) => (
                                                    <li key={i} className="flex items-start gap-2">
                                                        <Check size={14} className="text-[#eab308] shrink-0 mt-0.5" />
                                                        <span>{h}</span>
                                                    </li>
                                                ))}
                                            </ul>

                                            {/* Bottom Card Footer */}
                                            <div className="pt-3 border-t border-white/10 flex items-center justify-between mt-auto">
                                                <span className="inline-block bg-yellow-500/10 text-yellow-400 border border-yellow-500/30 text-xs font-bold px-3 py-1.5 rounded-xl">
                                                    {item.priceTag}
                                                </span>
                                                <button
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setSelectedService(item);
                                                    }}
                                                    className="text-xs font-bold text-white group-hover:text-[#eab308] flex items-center gap-1 transition-colors"
                                                >
                                                    <span>Voir détails</span>
                                                    <ChevronRight size={14} className="group-hover:translate-x-1 transition-transform" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Interactive Lightbox Modal */}
                {selectedService && (
                    <div
                        className="fixed inset-0 z-[9999] bg-black/90 backdrop-blur-md flex items-center justify-center p-3 md:p-6"
                        onClick={() => setSelectedService(null)}
                    >
                        <div
                            className="relative bg-[#181818] border-2 border-[#eab308] rounded-3xl max-w-4xl w-full max-h-[92vh] overflow-hidden shadow-[0_15px_60px_rgba(234,179,8,0.3)] flex flex-col md:flex-row"
                            onClick={(e) => e.stopPropagation()}
                        >
                            {/* Close Button */}
                            <button
                                type="button"
                                onClick={() => setSelectedService(null)}
                                className="absolute top-4 right-4 z-20 bg-black/70 hover:bg-[#eab308] hover:text-black text-white p-2 rounded-full border border-white/20 transition-all duration-200 cursor-pointer"
                                title="Fermer"
                            >
                                <X size={20} />
                            </button>

                            {/* Poster Preview on Left */}
                            <div className="md:w-1/2 bg-black/90 p-4 flex items-center justify-center border-b md:border-b-0 md:border-r border-white/10">
                                <img
                                    src={selectedService.image}
                                    alt={selectedService.title}
                                    className="max-h-[50vh] md:max-h-[80vh] w-auto max-w-full object-contain rounded-2xl shadow-2xl"
                                />
                            </div>

                            {/* Details on Right */}
                            <div className="md:w-1/2 p-6 md:p-8 flex flex-col justify-between overflow-y-auto text-left">
                                <div>
                                    <div className="flex items-center gap-2 mb-2">
                                        <span className="bg-[#eab308] text-black font-extrabold text-xs px-3 py-1 rounded-full uppercase tracking-wider">
                                            {selectedService.badge}
                                        </span>
                                        <span className="text-yellow-400 text-xs font-semibold">
                                            {selectedService.priceTag}
                                        </span>
                                    </div>

                                    <span className="text-xs font-bold text-gray-400 uppercase tracking-widest block mb-1">
                                        {selectedService.tagline}
                                    </span>

                                    <h3 className="text-2xl md:text-3xl font-black text-white mb-4">
                                        {selectedService.title}
                                    </h3>

                                    <p className="text-gray-300 text-sm leading-relaxed mb-6">
                                        {selectedService.description}
                                    </p>

                                    <div className="bg-[#222222] p-4 rounded-2xl border border-white/10 mb-6">
                                        <h4 className="text-xs font-extrabold text-[#eab308] uppercase tracking-wider mb-2.5">
                                            Ce que comprend cette formule :
                                        </h4>
                                        <ul className="space-y-2 text-xs md:text-sm text-gray-200">
                                            {selectedService.highlights.map((h, i) => (
                                                <li key={i} className="flex items-start gap-2.5">
                                                    <Check size={16} className="text-[#eab308] shrink-0 mt-0.5" />
                                                    <span>{h}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>

                                {/* Actions */}
                                <div className="pt-4 border-t border-white/10 flex flex-col sm:flex-row gap-3">
                                    <a
                                        href="tel:0101585053"
                                        className="btn py-2.5 px-4 font-bold rounded-xl flex items-center justify-center gap-2 transition-all"
                                        style={{ backgroundColor: '#eab308', color: 'black' }}
                                    >
                                        <Phone size={16} />
                                        <span>Appeler le club</span>
                                    </a>
                                    <a
                                        href="#contact-section"
                                        onClick={() => setSelectedService(null)}
                                        className="btn btn-outline-white py-2.5 px-4 font-bold rounded-xl flex items-center justify-center gap-2"
                                    >
                                        <span>Nous contacter</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div className="site-section bg-light contact-wrap" id="contact-section">
                    <div className="container">

                        <div className="row justify-content-center text-center mb-5">
                            <div className="col-md-8  section-heading">
                                <span className="subheading font-extrabold uppercase tracking-widest text-sm" style={{ color: "#eab308" }}>Get In Touch</span>
                                <h2 className="heading mb-3 font-extrabold text-4xl" style={{ color: "#eab308" }}>Contact Us</h2>
                                <p className="text-gray-300 leading-relaxed text-gray-300 leading-relaxed">Des coachs passionnés pour vous guider, vous motiver et vous aider à dépasser vos limites, quel que soit votre niveau.
                                </p>
                            </div>
                        </div>

                        <div className="row justify-content-center">
                            <div className="col-md-7">
                                <form method="post" data-aos="fade">
                                    <div className="form-group row">
                                        <div className="col-md-6 mb-3 mb-lg-0">
                                            <input type="text" className="form-control" placeholder="First name" />
                                        </div>
                                        <div className="col-md-6">
                                            <input type="text" className="form-control" placeholder="Last name" />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <div className="col-md-12">
                                            <input type="text" className="form-control" placeholder="Subject" />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <div className="col-md-12">
                                            <input type="email" className="form-control" placeholder="Email" />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-md-12">
                                            <textarea className="form-control" id="" cols={30} rows={10}
                                                placeholder="Write your message here."></textarea>
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <div className="col-md-6">

                                            <input type="submit" className="btn btn-primary py-3 px-5 btn-block" value="Send Message" />
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="schedule-wrap2 clearfix p-4">
                    <div className="d-md-flex align-items-center justify-content-between">
                        <div className="hours mb-4 mb-lg-0 text-white flex-1 w-full">
                            <strong className="d-block text-white text-xl mb-3 font-black uppercase tracking-wider">HORAIRE (Ouvert 7J/7)</strong>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm">
                                <div className="space-y-2">
                                    <div className="flex justify-between border-b border-white/20 pb-1"><span className="font-bold text-white">LUNDI-SAMEDI :</span> <span className="text-white font-medium">06H30 - 22H30</span></div>
                                    <div className="flex justify-between border-b border-white/20 pb-1"><span className="font-bold text-white">DIMANCHE :</span> <span className="text-white font-medium">09H00 - 20H00</span></div>
                                    <div className="flex justify-between border-b border-white/20 pb-1"><span className="font-bold text-white">FÉRIÉ :</span> <span className="text-white font-medium">06H30 - 22H30</span></div>
                                </div>
                                <div className="bg-white/10 p-3 rounded-lg border border-white/30 text-xs text-white">
                                    <span className="text-white font-bold block mb-1">⚠️ NB :</span>
                                    LA PAUSE EST DE 12H30 À 15H30. LES CLIENTS PEUVENT S'ENTRAÎNER LIBREMENT, MAIS SANS LES COACHS.
                                </div>
                            </div>
                        </div>
                        <div className="cta ml-md-8 mt-4 md:mt-0 flex flex-col items-center justify-center shrink-0">
                            <div className="text-white font-black text-2xl mb-3 bg-black/20 px-4 py-2 rounded-lg whitespace-nowrap">
                                📞 01 01 58 50 53
                            </div>
                            <a href="#contact-section" className="smoothscroll d-flex d-md-flex align-items-center btn w-full" style={{ backgroundColor: '#eab308', color: 'black' }}>
                                <span className="mx-auto">  <span>Nous contacter</span> <span className="arrow icon-keyboard_arrow_right"></span></span>
                            </a>
                        </div>
                    </div>
                </div>

                <footer className="footer-section bg-[#0a0a0a] pt-16 pb-8 border-t border-yellow-500/20">
                    <div className="container">
                        <div className="row mb-12">
                            <div className="col-md-4 mb-8 md:mb-0">
                                <h3 className="font-extrabold text-2xl mb-6 uppercase tracking-wider" style={{ color: '#eab308' }}>À propos</h3>
                                <p className="text-gray-400 leading-relaxed pr-4 text-gray-300 leading-relaxed">Découvrez nos installations modernes et nos cours variés pour tous les niveaux. Rejoignez notre communauté pour transformer votre vie par le fitness.</p>
                            </div>

                            <div className="col-md-3 ml-auto mb-8 md:mb-0">
                                <h3 className="font-extrabold text-2xl mb-6 uppercase tracking-wider" style={{ color: '#eab308' }}>Liens utiles</h3>
                                <ul className="list-unstyled footer-links space-y-3">
                                    <li><a href="#home-section" className="text-gray-400 hover:text-yellow-500 transition-colors duration-300">Accueil</a></li>
                                    <li><a href="#classes-section" className="text-gray-400 hover:text-yellow-500 transition-colors duration-300">Cours</a></li>
                                    <li><a href="#shop-section" className="text-gray-400 hover:text-yellow-500 transition-colors duration-300">Boutique</a></li>
                                    <li><a href="#trainer-section" className="text-gray-400 hover:text-yellow-500 transition-colors duration-300">Entraîneurs</a></li>
                                </ul>
                            </div>


                            <div className="col-md-4">
                                <h3 className="font-extrabold text-2xl mb-6 uppercase tracking-wider" style={{ color: '#eab308' }}>S'abonner</h3>
                                <p className="text-gray-400 leading-relaxed mb-4 text-gray-300 leading-relaxed">Restez informé de nos offres exclusives et nouveautés.
                                </p>
                                <form action="#">
                                    <div className="d-flex rounded-lg overflow-hidden border border-gray-800 focus-within:border-yellow-500 transition-colors">
                                        <input type="text" className="form-control rounded-0 bg-[#1a1a1a] text-white border-0 shadow-none px-4 py-3 placeholder-gray-600 focus:ring-0" placeholder="Adresse email" />
                                        <input type="submit" className="btn rounded-0 px-6 font-bold cursor-pointer transition-colors" value="S'abonner" style={{ backgroundColor: '#eab308', color: '#000', border: 'none' }} />
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div className="row pt-8 mt-8 text-center border-t border-gray-800">
                            <div className="col-md-12">
                                <p className="copyright text-gray-500 text-sm text-gray-300 leading-relaxed">
                                    <small>&copy; {new Date().getFullYear()} HopFitness. Tous droits réservés.</small>
                                </p>
                            </div>
                        </div>
                    </div>
                </footer>



            </div>
            {/* .site-wrap */}


        </>
    );
};

export default LandingPage;
